

$(document).ready(function(){
  $('.personalized_cardslider, .dynamic-cards-slider, .featurecollection, .shop_collection').slick({
    slidesToShow: 3 ,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones
           arrows: true, // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones

        }
      },
      {
        breakpoint: 576,
        settings: {
         slidesToShow: 1,
         variableWidth: false,
         infinite: true,
           centerMode: true,
          centerPadding: '40px'
        }
      }  
    ]
  });
});
$(document).ready(function(){
  $('.dynamic-cards-slider').slick({
    slidesToShow: 3 ,
    slidesToScroll: 1,
    arrows: true,
     autoplaySpeed: 10000,
    autoplay:true,
    loop: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones
          arrows: true, // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones

        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1, // Show 1 slide on very small screens

        }
      }
    ]
  });
});
$(document).ready(function(){
  $('.featurecollection').slick({
    slidesToShow: 3 ,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones
           arrows: true, // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones
           arrows: true, // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1, // Show 1 slide on very small screens
           arrows: true,
        }
      }
    ]
  });
});






$(document).ready(function(){
  $('.home_cardslider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots:true,
    autoplaySpeed: 10000,
    autoplay:true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow:1, // Show 2 slides on small tablets and large phones
           arrows: true, // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1, // Show 1 slide on very small screens
           arrows: false,
        }
      }
    ]
  });
});


$(document).ready(function(){
  $('.intentionslider').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4, // Show 4 slides on medium screens
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3, // Show 3 slides on tablets
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones
         arrows: true,
        }
      },
      {
        breakpoint: 576,
       settings: "unslick"
      }
    ]
  });
});

$(document).ready(function(){
  $('.verient_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2, // Show 3 slides on tablets
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2, // Show 3 slides on tablets
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:2, // Show 2 slides on small tablets and large phones
          arrows: false // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2, // Show 1 slide on very small screens
          arrows: false
        }
      }
    ]
  });
});
// $(document).ready(function(){
//   $('.jdgm-rev-widg__reviews1').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: true,
//     prevArrow: '<button type="button" class="slick-prev"></button>',
//     nextArrow: '<button type="button" class="slick-next"></button>',
//     responsive: [
//       {
//         breakpoint: 1366,
//         settings: {
//           slidesToShow: 3, // Show 3 slides on tablets
//         }
//       },
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 2, // Show 3 slides on tablets
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow:2, // Show 2 slides on small tablets and large phones
//           arrows: false // Hide arrows on smaller screens
//         }
//       },
//       {
//         breakpoint: 576,
//         settings: {
//           slidesToShow: 1, // Show 1 slide on very small screens
//           arrows: true
//         }
//       }
//     ]
//   });
// });




  $(document).ready(function () {
    $('.coll-btn-scroll').on('click', function () {
      $('html, body').animate({ scrollTop: $(window).scrollTop() + 300 }, 'slow'); // Adjust speed as needed
    });
  });


/////////////////

  $(document).ready(function(){
  $('.related_pr_slider ').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3 // Show 3 slides on larger tablets
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2 // Show 2 slides on tablets
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // Show 2 slides on small tablets and large phones
          arrows: false // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1, // Show 1 slide on very small screens
          arrows: false // Hide arrows on smaller screens
        }
      }
    ]
  });
    });
$(document).ready(function(){
      $('.why_chosee_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // Show 2 slides on small tablets and large phones
          arrows: true,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1, // Show 1 slide on very small screens
          arrows: false,
          variableWidth: false,
          infinite: true,
          centerMode: true,
          centerPadding: '40px'
        }
      }
    ]
  });
});




$(document).ready(function(){
	
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

});

$(document).ready(function () {
    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 50) {
            $("body").addClass("remove_crc");
        } else {
            $("body").removeClass("remove_crc");
        }
    });
});

$('.moreless-button').click(function() {
  $('.moretext').slideToggle();
  if ($('.moreless-button').text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});

$("body").bind("DOMNodeInserted", function() {
        var $this = $(this).find('.slick-initialized');
        window.setTimeout(function(){
        $this.addClass('finally-loaded');
    }, 2000);
});





let items = document.querySelectorAll(".mega-menu");
let currentItemIndex = null;
let closeTimeout;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");

  item.addEventListener("mouseover", () => {
    if (currentItemIndex !== null && currentItemIndex !== itemIndex) {
      items[currentItemIndex].removeAttribute("open");
    }
    currentItemIndex = itemIndex;
    item.setAttribute("open", true);

    // Clear any existing close timeout if the user hovers back
    if (closeTimeout) {
      clearTimeout(closeTimeout);
    }
  });

  item.addEventListener("mouseleave", () => {
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 500); // Delay before closing
  });

  content.addEventListener("mouseenter", () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout); // Prevent closing when hovering over content
    }
  });

  content.addEventListener("mouseleave", () => {
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 500);
  });
});

// Close menu on scroll
window.addEventListener("scroll", () => {
  items.forEach((item) => item.removeAttribute("open"));
  currentItemIndex = null;
});


// JavaScript to add 'sticky_on' class when scrolled 150px
document.addEventListener("scroll", function () {
    const header = document.querySelector("sticky-header"); // Adjust selector if needed
    if (window.scrollY > 1) {
        header.classList.add("sticky_on");
    } else {
        header.classList.remove("sticky_on");
    }
});


$(document).ready(function () {
  // Remove the active class when the page loads
  $('#Details-HeaderMenu-1 .header__menu-item > span').removeClass('header__active-menu-item');

  // Remove the active class when the "Home" logo is clicked
  $('#home-logo').on('click', function () {
    $('#Details-HeaderMenu-1 .header__menu-item > span').removeClass('header__active-menu-item');
  });

  // Add the active class when a menu item is clicked
  $('#Details-HeaderMenu-1 .header__menu-item > span').on('click', function () {
    $(this).addClass('header__active-menu-item').siblings().removeClass('header__active-menu-item');
  });
});

// page visitor function start
function updateVisitCount() {
  const today = new Date().toDateString();
  const visitData = JSON.parse(localStorage.getItem('visitData')) || { count: 96, lastVisit: null };

  if (!visitData.lastVisit || visitData.lastVisit !== today) {
    // Increment count by a random number between 5 and 10
    const randomIncrement = Math.floor(Math.random() * 6) + 5;
    visitData.count += randomIncrement;
    visitData.lastVisit = today;
    localStorage.setItem('visitData', JSON.stringify(visitData));
  }

  return visitData.count;
}

function displayCounter(count) {
  const counterElement = document.getElementById('visitCounter');
  counterElement.innerHTML = ''; // Clear previous digits

  // Convert count to a string and display each digit
  String(count).split('').forEach((digit) => {
    const digitElement = document.createElement('div');
    digitElement.className = 'digit';
    digitElement.textContent = digit;
    counterElement.appendChild(digitElement);
  });
}

// Initialize
const visitCount = updateVisitCount();
displayCounter(visitCount);


// $(document).ready(function () {
//   // Hide all FAQ sections initially
  
//   $(".faq_Crystal, .faq_shipping, .faq_order, .faq_return, .faq_Purchase, .faq_Connected, .faq_Benefits, .faq_Reuse, .faq_Materials, .faq_Crystals, .faq_Features, .faq_Tracking, .faq_Customization, .faq_Jewelry, .faq_Why-gem").removeClass("active");
//   $('.faq_Crystal').addClass('active');
//   // Add a single click event listener for all buttons
//   $("[class^='btn-']").click(function () {
//     // Hide all FAQ sections
//     $(".faq_Crystal, .faq_shipping, .faq_order, .faq_return, .faq_Purchase, .faq_Connected, .faq_Benefits, .faq_Reuse, .faq_Materials, .faq_Crystals, .faq_Features, .faq_Tracking, .faq_Customization, .faq_Jewelry, .faq_Why-gem").removeClass("active");

//     // Get the related FAQ class from the button's class
//     const relatedFaq = $(this).attr("class").split("btn-")[1];
//     $(`.faq_${relatedFaq}`).toggleClass("active");
//   });
// });

$(document).ready(function () {
  // Hide all FAQ sections initially
  $(".faq_Crystal, .faq_shipping, .faq_order, .faq_return, .faq_Purchase, .faq_Connected, .faq_Benefits, .faq_Reuse, .faq_Materials, .faq_Crystals, .faq_Features, .faq_Tracking, .faq_Customization, .faq_Jewelry, .faq_Gemanifest").removeClass("active");

  // Set the default active FAQ section and button
  $(".faq_Crystal").addClass("active");
  $(".btn-Crystal").addClass("active btn-open");

  // Function to update button states
  function updateButtonState(button) {
    // Remove active and btn-open from all buttons
    $("[class^='btn-']").removeClass("active btn-open");

    // Add active and btn-open to the clicked button
    $(button).addClass("active btn-open");
  }

  // Add click event listener to all buttons
  $("[class^='btn-']").click(function () {
    // Log for debugging
    console.log('Button clicked:', this);

    // Update button state
    updateButtonState(this);

    // Hide all FAQ sections
    $(".faq_Crystal, .faq_shipping, .faq_order, .faq_return, .faq_Purchase, .faq_Connected, .faq_Benefits, .faq_Reuse, .faq_Materials, .faq_Crystals, .faq_Features, .faq_Tracking, .faq_Customization, .faq_Jewelry, .faq_Gemanifest").removeClass("active");

    // Get the related FAQ class from the button's class
    const relatedFaq = $(this).attr("class").match(/btn-(\w+-?\w+)/)[1];
    console.log('Related FAQ:', relatedFaq);  // Log to verify

    // Show the corresponding FAQ section
    $(`.faq_${relatedFaq}`).addClass("active");
  });
});
$(document).ready(function () {
      $('.crystal-filter h4').click(function () {
        $('.crystal-filter ul, .crystal-filter h4').toggleClass("active");
        $('.shop-for-filter  ul, .zodiac-filter  ul, .intention-filter  ul, .chakra-filter ul, bestsaller_for_tags  ul, .occasion-filter  h4').removeClass("active");
        $('.chakra-filter h4, .intention-filter  h4, .zodiac-filter  h4, .shop-for-filter  h4, bestsaller_for_tags  h4, .occasion-filter  ul').removeClass("active");
      });
        $('.chakra-filter h4').click(function () {
        $('.chakra-filter ul, .chakra-filter h4').toggleClass("active");
        $('.shop-for-filter  ul, .zodiac-filter  ul, .intention-filter  ul, .crystal-filter ul, .bestsaller_for_tags  ul, .occasion-filter  h4').removeClass("active");
          $('.crystal-filter h4, .intention-filter  h4, .zodiac-filter  h4, .shop-for-filter  h4, .bestsaller_for_tags  h4, .occasion-filter  ul').removeClass("active");
      });
        $('.intention-filter  h4').click(function () {
        $('.intention-filter  ul, .intention-filter  h4').toggleClass("active");
        $('.shop-for-filter  ul, .zodiac-filter  ul, .chakra-filter ul, .crystal-filter ul, .bestsaller_for_tags  ul, .occasion-filter  h4').removeClass("active");
          $('.crystal-filter h4, .chakra-filter h4, .zodiac-filter  h4, .shop-for-filter  h4, .bestsaller_for_tags  h4, .occasion-filter  ul').removeClass("active");
      });
        $('.zodiac-filter  h4').click(function () {
        $('.zodiac-filter  ul, .zodiac-filter  h4').toggleClass("active");
        $('.shop-for-filter  ul, .intention-filter  ul, .chakra-filter ul, .crystal-filter ul, .bestsaller_for_tags  ul, .occasion-filter  h4').removeClass("active");
          $('.crystal-filter h4, .chakra-filter h4, .intention-filter  h4, .shop-for-filter  h4, .bestsaller_for_tags  h4, .occasion-filter  ul').removeClass("active");
      });
        $('.shop-for-filter  h4').click(function () {
        $('.shop-for-filter  ul, .shop-for-filter  h4').toggleClass("active");
        $('.zodiac-filter  ul, .intention-filter  ul, .chakra-filter ul, .crystal-filter ul, .bestsaller_for_tags  ul, .occasion-filter  h4').removeClass("active");
          $('.crystal-filter h4, .chakra-filter h4, .intention-filter  h4, .zodiac-filter  h4, .bestsaller_for_tags  h4, .occasion-filter  ul').removeClass("active");
      });
      $('.bestsaller_for_tags  h4').click(function () {
        $('.bestsaller_for_tags  ul, .bestsaller_for_tags  h4').toggleClass("active");
        $('.zodiac-filter  ul, .intention-filter  ul, .chakra-filter ul, .crystal-filter ul, .shop-for-filter  ul, .occasion-filter  h4').removeClass("active");
          $('.crystal-filter h4, .chakra-filter h4, .intention-filter  h4, .zodiac-filter  h4, .shop-for-filter  h4, .occasion-filter  ul').removeClass("active");
      });
      $('.occasion-filter  h4').click(function () {
        $('.occasion-filter  ul, .occasion-filter  h4').toggleClass("active");
        $('.zodiac-filter  ul, .intention-filter  ul, .chakra-filter ul, .crystal-filter ul, .shop-for-filter  ul, .bestsaller_for_tags ul').removeClass("active");
          $('.crystal-filter h4, .chakra-filter h4, .intention-filter  h4, .zodiac-filter  h4, .shop-for-filter  h4, .bestsaller_for_tags  h4').removeClass("active");
      });


  bestsaller_for_tags
     $('.filter_cd_comon ul li a.filter-link').click(function (e) {
          e.preventDefault();
          
          // Remove active class from all links
          $('.filter_cd_comon ul li a.filter-link').removeClass('active');
          
          // Add active class to the clicked link
          $(this).addClass('active');
      });
  });






$(document).ready(function () {

  // Step 1: Get all product elements
  const products = document.querySelectorAll('.grid__item');
  console.log('Products:', products); // Debug: Check if products are selected correctly

  // Step 2: Add event listeners to filter links
  const filterLinks = document.querySelectorAll('.filter-link');
  console.log('Filter Links:', filterLinks); // Debug: Check if filter links are selected correctly

  filterLinks.forEach(link => {
    link.addEventListener('click', function () {
      console.log('Clicked:', this); // Debug: Check which link is clicked
      const selectedTag = this.getAttribute('data-tag');
      console.log('Selected Tag:', selectedTag); // Debug: Check the selected tag

      // Step 3: Filter products based on the selected tag
      products.forEach(product => {
        const productTags = product.getAttribute('data-tags');
        console.log('Product Tags:', productTags); // Debug: Check product tags
        if (selectedTag === '' || productTags.includes(selectedTag)) {
          product.style.display = 'block'; // Show the product
        } else {
          product.style.display = 'none'; // Hide the product
        }
      });

      // Step 4: Highlight the active filter
      filterLinks.forEach(link => {
        link.classList.remove('active');
        console.log('Removed active class from:', link); // Debug: Check active class removal
      });
      this.classList.add('active');
      console.log('Added active class to:', this); // Debug: Check active class addition
    });
  });

  // Step 5: Clear Filter functionality
  const clearFilterButton = document.getElementById('clear-filter');
  console.log('Clear Filter Button:', clearFilterButton); // Debug: Check if clear button is selected

  clearFilterButton.addEventListener('click', function () {
    console.log('Clear Filter Clicked'); // Debug: Check if clear filter is clicked
    // Show all products
    products.forEach(product => product.style.display = 'block');

    // Remove active class from all filter links
    filterLinks.forEach(link => {
      link.classList.remove('active');
      console.log('Removed active class from:', link); // Debug: Check active class removal
    });
  });



document.addEventListener("DOMContentLoaded", function () {
  let cartWarnings = document.querySelector(".cart__warnings");
  
  if (
    cartWarnings &&
    cartWarnings.querySelector(".cart__login-title") &&
    cartWarnings.querySelector(".cart__login-paragraph")
  ) {
    document.body.classList.add("withoutlogin");
  }
});


  });




$(document).ready(function () {
    if ($(".cart__warnings").find(".cart__login-title").length > 0 && $(".cart__warnings").find(".cart__login-paragraph").length > 0) {
        $("body").addClass("cart_withoutlogin");
    }
    setTimeout(function () {
        $(".cd-preloader").fadeOut(100, function () {
            $(this).removeClass("active"); 
        });
    }, 3000); 

});


// document.addEventListener('DOMContentLoaded', function () {
//   function attachBuyNowHandler(buttons) {
//     buttons.forEach(button => {
//       button.addEventListener('click', async (event) => {
//         let variantId = event.currentTarget.getAttribute('data-variant-id');

//         if (!variantId || variantId === "null") {
//           alert('Variant is missing, please try again.');
//           return;
//         }

//         try {
//           button.disabled = true;
//           button.textContent = 'Checking out...';

//           const clearCart = await fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' });

//           if (!clearCart.ok) {
//             throw new Error('Failed to clear cart');
//           }

//           window.location.href = `${window.Shopify.routes.root}checkout/?updates[${variantId}]=1`;
//         } catch (error) {
//           console.error('Error:', error);
//           alert('Something went wrong, please refresh and try again.');
//           button.disabled = false;
//           button.textContent = 'Buy Now';
//         }
//       });
//     });
//   }

//   // Normal product cards ke liye turant run hoga
//   attachBuyNowHandler(document.querySelectorAll('.buyWithproductCard'));

//   // Related products ke liye 1 second delay ke baad run hoga
//   setTimeout(() => {
//     attachBuyNowHandler(document.querySelectorAll('.related-products .buyWithproductCard'));
//   }, 1000);
// });




// Improved scroll behavior for collection products
function setupHorizontalScroll() {
  const scrollContainers = document.querySelectorAll('.collection-products, .QuizResult_products_container');
  
  scrollContainers.forEach(container => {
    // Remove any existing wheel event listeners to prevent duplicates
    container.removeEventListener('wheel', handleWheel);
    container.addEventListener('wheel', handleWheel, { passive: true });
  });
}

function handleWheel(e) {
  const scrollContainer = e.currentTarget;
  const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth;
  
  if (!isScrollable) return;
  
  const atScrollEnd = scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 1;
  const atScrollStart = scrollContainer.scrollLeft <= 0;
  
  // Only prevent default if we're actually scrolling horizontally
  if ((e.deltaY > 0 && !atScrollEnd) || (e.deltaY < 0 && !atScrollStart)) {
    e.preventDefault();
    scrollContainer.scrollLeft += e.deltaY;
  }
}

// Initialize with a small delay to ensure DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Initial setup
  setupHorizontalScroll();
  
  // Re-run setup after AJAX content loads (for infinite scroll/filtering)
  const observer = new MutationObserver(setupHorizontalScroll);
  observer.observe(document.body, { childList: true, subtree: true });
});









